const SVG_NS = 'http://www.w3.org/2000/svg';

function svg(viewBox: string, sizeRem: number, className?: string): SVGSVGElement {
  const el = document.createElementNS(SVG_NS, 'svg');
  el.setAttribute('viewBox', viewBox);
  el.style.width = `${sizeRem}rem`;
  el.style.height = `${sizeRem}rem`;
  if (className) el.setAttribute('class', className);
  return el;
}

function shape(name: string, attrs: Record<string, string>): SVGElement {
  const el = document.createElementNS(SVG_NS, name);
  for (const [k, v] of Object.entries(attrs)) el.setAttribute(k, v);
  return el;
}

export function createStarIcon(sizeRem = 2, className?: string): SVGSVGElement {
  const root = svg('0 0 100 100', sizeRem, className);
  root.appendChild(
    shape('polygon', {
      points: '50,5 61,38 96,38 68,58 78,92 50,72 22,92 32,58 4,38 39,38',
      fill: '#FFD23F',
      stroke: '#2A2154',
      'stroke-width': '6',
      'stroke-linejoin': 'round',
    }),
  );
  return root;
}

export function createClockIcon(sizeRem = 2, pulse = false): SVGSVGElement {
  const root = svg('0 0 100 100', sizeRem, pulse ? 'pulse' : undefined);
  root.appendChild(
    shape('circle', { cx: '50', cy: '55', r: '38', fill: '#FF5C8A', stroke: '#2A2154', 'stroke-width': '6' }),
  );
  root.appendChild(
    shape('circle', { cx: '50', cy: '55', r: '30', fill: 'white', stroke: '#2A2154', 'stroke-width': '3' }),
  );
  root.appendChild(
    shape('line', { x1: '50', y1: '55', x2: '50', y2: '35', stroke: '#2A2154', 'stroke-width': '5', 'stroke-linecap': 'round' }),
  );
  root.appendChild(
    shape('line', { x1: '50', y1: '55', x2: '65', y2: '62', stroke: '#2A2154', 'stroke-width': '5', 'stroke-linecap': 'round' }),
  );
  root.appendChild(shape('circle', { cx: '50', cy: '55', r: '3', fill: '#2A2154' }));
  root.appendChild(
    shape('rect', { x: '44', y: '6', width: '12', height: '8', rx: '2', fill: '#2A2154' }),
  );
  return root;
}

export function createPlayIcon(sizeRem = 2): SVGSVGElement {
  const root = svg('0 0 24 24', sizeRem, 'icon-play');
  root.appendChild(shape('polygon', { points: '6,4 20,12 6,20', fill: 'white' }));
  return root;
}

export function createGearIcon(sizeRem = 1.625): SVGSVGElement {
  const root = svg('0 0 24 24', sizeRem);
  root.appendChild(
    shape('path', {
      d: 'M12 2 L13.5 5 L17 4.5 L17 8 L20 9 L18.5 12 L20 15 L17 16 L17 19.5 L13.5 19 L12 22 L10.5 19 L7 19.5 L7 16 L4 15 L5.5 12 L4 9 L7 8 L7 4.5 L10.5 5 Z',
      fill: '#2A2154',
      stroke: '#2A2154',
      'stroke-width': '1.5',
      'stroke-linejoin': 'round',
    }),
  );
  root.appendChild(shape('circle', { cx: '12', cy: '12', r: '3', fill: 'white' }));
  return root;
}

export function createPauseIcon(sizeRem = 1.75): SVGSVGElement {
  const root = svg('0 0 24 24', sizeRem);
  root.appendChild(shape('rect', { x: '6', y: '4', width: '4', height: '16', rx: '1', fill: '#2A2154' }));
  root.appendChild(shape('rect', { x: '14', y: '4', width: '4', height: '16', rx: '1', fill: '#2A2154' }));
  return root;
}
